<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Validasi Ujian">
            <common-training-header/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.class_sessions"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :defaultExpandAllRows="true"
                >

                <a-table-column key="class_session" title="Kelas" className="text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                    <a-table
                        class="pcp-table"
                        :dataSource="record.sessions"
                        rowKey="id"
                        :loading="loading"
                        :pagination="false"
                        bordered
                    >

                        <a-table-column key="session" title="Sesi Pelatihan" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                {{ innerRecord.name }}
                            </template>
                        </a-table-column>

                        <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                {{ innerRecord.inspirator.name }}
                            </template>
                        </a-table-column>

                        <a-table-column key="schedule" title="Jadwal Ujian" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <a-icon type="calendar" theme="filled" />
                                <strong> {{ moment(innerRecord.exam_time_start).format('DD MMMM YYYY HH:mm:ss') }} </strong> <br/>
                                <a-tooltip>
                                    <template slot="title">
                                        Durasi {{ innerRecord.exam_duration }} Menit
                                    </template>
                                    <a-icon type="clock-circle" theme="twoTone" /> {{ innerRecord.exam_duration }} Menit
                                </a-tooltip>
                            </template>
                        </a-table-column>

                        <a-table-column key="exam_status" title="Status" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <div style="text-align: center" v-show="moment().diff(moment(innerRecord.session_time_end, 'YYYY-MM-DD HH:mm:ss'), 'minutes') > 0 && 
                                    innerRecord.actual_exam_time_end != null">
                                    <a-tag color="green" v-if="innerRecord.exam_verification_level > 0">
                                       Sudah divalidasi
                                    </a-tag>
                                    <a-tag color="red" v-else>
                                       Belum divalidasi
                                    </a-tag>
                                </div>
                            </template>
                        </a-table-column>

                        <a-table-column key="action" title="Action" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <div v-show="innerRecord.actual_exam_time_end != null">
                                        <a-button type="primary" size="small"
                                            :loading="processing"
                                            @click="validationScore(record.id, innerRecord.id)"
                                            block >
                                            Validasi Ujian
                                        </a-button>
                                </div>
                            </template>
                        </a-table-column>

                    </a-table>
                </p>

            </a-table>
        </a-card>
    </div>
</template>

<script>

export default {
    created() {
        this.getItems();
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            processing: false,
            visible: false,
            items: {},
        };
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        currentRoute(){
            return this.$laravel.current_route
        },
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-exam.sessions"))
                .then(response => {
                    this.items = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        validationScore(class_id, session){
            let params = {
                session: session,
                class: class_id,
                previous: this.currentRoute
            }
            
            window.location.href = this.routeUri('admin.classical.exam.validation.score') + '?' + this.$qs.stringify(params)
        }
    }
};
</script>


